import eclipseIcon from './assets/eclipse.png'
import jetbrainsIcon from './assets/jetbrains.png'
import neovimIcon from './assets/neovim.png'
import vscodeIcon from './assets/vscode.png'
import vsstudioIcon from './assets/vsstudio.png'
import xcodeIcon from './assets/xcode.png'

export const xcodeInstallPageUrl = '/copilot/xcode/install'
export const xcodeLegacyUrl = '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/github/CopilotForXcode'

export default {
  vscode: {
    url: 'https://marketplace.visualstudio.com/items?itemName=GitHub.copilot-chat',
    icon: vscodeIcon,
    name: 'Visual Studio Code',
    eventName: 'VSCODE',
  },
  visualstudio: {
    url: 'https://visualstudio.microsoft.com/github-copilot/',
    icon: vsstudioIcon,
    name: 'Visual Studio',
    eventName: 'VS',
  },
  xcode: {
    url: xcodeLegacyUrl,
    icon: xcodeIcon,
    name: 'Xcode',
    eventName: 'XCODE',
  },
  jetbrains: {
    url: 'https://plugins.jetbrains.com/plugin/17718-github-copilot',
    icon: jetbrainsIcon,
    name: 'JetBrains',
    eventName: 'JETBRAINS',
  },
  eclipse: {
    url: 'https://marketplace.eclipse.org/content/github-copilot',
    icon: eclipseIcon,
    name: 'Eclipse',
    eventName: 'ECLIPSE',
  },
  neovim: {
    url: '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/github/copilot.vim',
    icon: neovimIcon,
    name: 'Neovim',
    eventName: 'NEOVIM',
  },
}
